import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KeycloakDevice } from '../models/keycloak-session';
import { NimmstaCommonsModuleConfiguration } from '../nimmsta-commons-module.config';

@Injectable({
  providedIn: 'root',
})
export class KeycloakSessionService {
  private readonly sessionEndpoint;

  private http = inject(HttpClient);
  private configuration = inject(NimmstaCommonsModuleConfiguration);

  constructor() {
    this.sessionEndpoint = `${this.configuration.keycloakUrl}/realms/${this.configuration.keycloakRealm}/account/sessions`;
  }

  public getActiveDevices(): Observable<KeycloakDevice[]> {
    return this.http.get<KeycloakDevice[]>(`${this.sessionEndpoint}/devices`);
  }

  public terminate(sessionId: string): Observable<void> {
    return this.http.delete<void>(`${this.sessionEndpoint}/${sessionId}`);
  }

  public terminateAll(): Observable<void> {
    return this.http.delete<void>(`${this.sessionEndpoint}`);
  }
}
